import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type IPrivateFolder, privateFoldersManager } from '@inpart-io/padme-iap';

import { getSearchModule } from '@/store/base/search/module';

import { store } from '..';
import { actions } from './actions';

const PRIVATE_FOLDER_MODULE = 'privatefolder';

const dataObjectModule = getDataObjectsModule<IPrivateFolder>(privateFoldersManager, 5);
const searchModule = getSearchModule<IPrivateFolder>(privateFoldersManager);

const privateFolderModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(PRIVATE_FOLDER_MODULE, privateFolderModuleInstance);

export { PRIVATE_FOLDER_MODULE };
